module.exports = __webpack_public_path__ + "static/media/hair (2).eb5d1a3c.jpg";